import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { ElementType, FC } from 'react';

import { IcSReadDone16Icon, IcSTimeIcon, MessageErrorIcon, SentIcon } from '@gem/icons';
import { IconView, IconViewSizes } from '@gem/ui-kit';

import { ChatMessage } from 'APP/store/Messages/Message/ChatMessage/ChatMessage';

import styles from './MessageViewsStatusIcon.styles.m.css';

interface IIconInfo {
  Icon: ElementType;
  className: string;
  dataTest: string;
}

export const getIconInfo = (message: ChatMessage): IIconInfo | null => {
  if (message.isFailed) {
    return {
      Icon: MessageErrorIcon,
      className: styles.failed,
      dataTest: 'status-failed',
    };
  }

  if (message.isSeen) {
    return {
      Icon: IcSReadDone16Icon,
      className: styles.default,
      dataTest: 'status-seen',
    };
  }

  if (message.isSending) {
    return {
      Icon: IcSTimeIcon,
      className: styles.sending,
      dataTest: 'status-sending',
    };
  }

  if (message.isSent) {
    return {
      Icon: SentIcon,
      className: styles.default,
      dataTest: 'status-sent',
    };
  }

  return null;
};

interface IMessageViewsStatusIconProps {
  message: ChatMessage;
  fixedColor: boolean;
}

export const MessageViewsStatusIcon: FC<IMessageViewsStatusIconProps> = observer(
  ({ message, fixedColor }) => {
    const info = getIconInfo(message);

    if (!info) {
      return null;
    }

    const { Icon, className, dataTest } = info;

    const iconClassName = classNames(styles.icon, className, {
      [styles.fixedColor]: fixedColor,
    });

    return (
      <IconView
        Icon={Icon}
        size={IconViewSizes.Small}
        className={iconClassName}
        dataTest={dataTest}
      />
    );
  }
);
